import { Component, Input } from '@angular/core';
import { ActivityLog } from '../../../models/activity-log.model';
import * as moment from 'moment';
declare var jQuery: any;

@Component({
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss'],
  selector: 'lowy-activity-log'
})
export class ActivityLogComponent {
  @Input('data') data: any;

  activityLogGroups: Array<ActivityLogGroup>;

  public buildLog () {
    setTimeout(() => {
      // unsure why but this.data isn't ready unless we wait a tick
      this.activityLogGroups = this.groupActivityLog(this.buildActivityLogs(this.data.activityLog));
      this.truncateNotes();
    });
  }

  buildActivityLogs(activityLogs: Array<ActivityLog>): Array<ActivityLog> {
    if (!activityLogs) {
      return activityLogs;
    }

    for (let i = 0; i < activityLogs.length; i++) {
      activityLogs[i]['displayDate'] = moment(activityLogs[i].createdAt).format('MMM DD, YYYY');

      const oldValue = activityLogs[i].oldValue;
      const newValue = activityLogs[i].newValue;
      if (activityLogs[i].fieldName === 'dataCreated') {
        activityLogs[i]['changeType'] = 'uploaded';
      }
      else if (activityLogs[i].fieldName === 'dataApproved') {
        activityLogs[i]['changeType'] = 'approved';
      }
      else if (oldValue && !newValue) {
        activityLogs[i]['changeType'] = 'removed';
      }
      else if (newValue && !oldValue) {
        activityLogs[i]['changeType'] = 'added';
      }
      else {
        activityLogs[i]['changeType'] = 'edited';
      }
    }

    return activityLogs;
  }

  groupActivityLog(activityLogs: Array<ActivityLog>): Array<ActivityLogGroup> {
    if (!activityLogs) {
      return [];
    }

    const activityLogGroups: Array<ActivityLogGroup> = [
      {key: 'today', logs: []}, {key: 'earlier this week', logs: []}, {key: 'last week', logs: []}, {key: 'earlier this month', logs: []},
      {key: 'last month', logs: []}, {key: 'earlier this year', logs: []}, {key: 'last year', logs: []}, {key: 'long ago', logs: []}
    ];

    // Array is managed by index, so the groups are in discrete order
    for (let i = 0; i < activityLogs.length; i++) {
      const log = activityLogs[i];
      const logDate = moment(log.createdAt);

      // Today
      if (moment().startOf('day').isBefore(logDate)) {
        log['displayDate'] = moment(log.createdAt).format('h:mm A');
        activityLogGroups[0].logs.push(log);
      }
      // Earlier this week
      else if (moment().startOf('week').isBefore(logDate)) {
        log['displayDate'] = moment(log.createdAt).format('ddd h:mm A');
        activityLogGroups[1].logs.push(log);
      }
      // Last week
      else if (moment().subtract(1, 'week').startOf('week').isBefore(logDate)) {
        activityLogGroups[2].logs.push(log);
      }
      // Earlier this month
      else if (moment().startOf('month').isBefore(logDate)) {
        activityLogGroups[3].logs.push(log);
      }
      // Last month
      else if (moment().subtract(1, 'month').startOf('month').isBefore(logDate)) {
        activityLogGroups[4].logs.push(log);
      }
      // Earlier this year
      else if (moment().startOf('year').isBefore(logDate)) {
        activityLogGroups[5].logs.push(log);
      }
      // Last year
      else if (moment().subtract(1, 'year').startOf('year').isBefore(logDate)) {
        activityLogGroups[6].logs.push(log);
      }
      // Long ago
      else {
        activityLogGroups[7].logs.push(log);
      }
    }

    // Remove log-less groups so they don't display
    const retVal = [];
    for (let i = 0; i < activityLogGroups.length; i++) {
      if (activityLogGroups[i].logs.length !== 0) {
        retVal.push(activityLogGroups[i]);
      }
    }
    return retVal;
  }

  truncateNotes() {
    jQuery(document).ready($ => {
      for (let i = 0; i < this.activityLogGroups.length; i++) {
        $('#log-' + i).dotdotdot({
          ellipsis: '...',
          watch: 'window',
          height: 60
        });
      }
    });
  }
}

class ActivityLogGroup {
  key: string;
  logs: ActivityLog[];
}



// WEBPACK FOOTER //
// ./src/app/home/data/activity-log/activity-log.component.ts